import { PerspectiveCamera } from "@react-three/drei";

interface AppCameraProps {
  position?: [number, number, number];
}

export default function AppCamera({ position }: AppCameraProps) {
  const safePosition: [number, number, number] =
    position && position.length === 3 ? position : [0, 0.01, 0];
  return <PerspectiveCamera makeDefault position={safePosition} fov={90} />;
}
